<script>
import displaySettings from "@/mixin/displaySettings";
import { CheckIcon, OpenDownIcon } from '@/shared/ui/icons';
import clsx from 'clsx';

export default {
    components: {OpenDownIcon},
    name: "HistoryTabs",
    mixins:[displaySettings],
    data() {
        return {
            listQuery: {
                statusId: 0,
            },
            isShowOther: false,
        }
    },
    computed:{
        orderStatuses: function () {
            return this.$store.getters.ORDER_STATUSES;
        },
    },
    methods: {
        clsx,
        activateTab :function (status) {
            this.$set(this.listQuery, 'statusId', status.id);
            this.$emit('change-tab', status)
        },
        isOtherTab(tabItem, isShowOther) {
          return ![0, 5, 10].includes(tabItem.id) && !isShowOther
        },
        showOtherTabs() {
          this.isShowOther = !this.isShowOther;
        }
    }
}
</script>

<template>
<div class="list-orders container"><!--  p-0 -->
    <div v-if="!isMobile" class="tabs-block">
        <ul class="status-tabs">
            <li @click="activateTab(status)" v-for="(status, index) in orderStatuses" class="tab" :class="{ 'other-tab': isOtherTab(status, isShowOther) }">
                <a v-bind:class="{ active: listQuery.statusId === status.id }"
                   href="javascript:void(0);"> {{ status.nameAlt || 'Всі' }}</a>
            </li>
            <li @click="showOtherTabs()" class="tab">
              <a href="javascript:void(0);">{{ !isShowOther ? 'Показати більше' : 'Згорнути' }}
                <OpenDownIcon
                  :class="clsx('mobile-main-menu-open-icon', { 'mobile-main-menu-open-icon__active': isShowOther })"
                  :color="'#717680'"
                />
              </a>
            </li>
        </ul>
    </div>
    <div v-else class="tabs-block-mobile">
        <div class="row form-group">
            <el-select v-model="listQuery.statusId"
                       class="form-control-el tabs-mobile-select"
                       placeholder="Виберіть статус"
                       @change="activateTab({id: $event})"
            >
                <el-option v-for="item in orderStatuses"
                           :key="item.id"
                           :label="item.nameAlt || 'Всі'"
                           :value="item.id"
                           >
                </el-option>
            </el-select>
        </div>
    </div>

    <slot name="content"></slot>
</div>
</template>

<style scoped lang="scss">
.mobile-main-menu-open-icon {
  margin-left: auto;
  transform: rotate(0deg);
  transition: transform 0.3s ease;

  &__active {
     transform: rotate(90deg);
  }
}
</style>
